import {
    NEWS_DETAILS_REQUEST,
    NEWS_DETAILS_SUCCESS,
    NEWS_DETAILS_FAILURE,
    NEWS_LIST_REQUEST,
    NEWS_LIST_SUCCESS,
    NEWS_LIST_FAILURE,
} from './types';

const initialState = {
    newsDetails: {},
    newsDetailsLoading: false,
    newsDetailsErrors: {},

    newsList: [],
    newsListLoading: false,
    newsListErrors: {},

    hasMore: false,
    currentPage: 1,
    newSearch: false, // Set to TRUE to reinitialize the search results (= fresh/new list)
    fakeLoadingTime: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case NEWS_DETAILS_REQUEST:
            return {
                ...state,
                newsDetailsLoading: true,
            };
        case NEWS_DETAILS_SUCCESS:
            return {
                ...state,
                newsDetailsLoading: false,
                newsDetailsErrors: {},
                newsDetails: action.payload,
            };
        case NEWS_DETAILS_FAILURE:
            return {
                ...state,
                newsDetailsLoading: false,
                newsDetails: {},
                newsDetailsErrors: action.payload,
            };
        case NEWS_LIST_REQUEST:
            return {
                ...state,
                newsListLoading: true,
            };
        case NEWS_LIST_SUCCESS:
            const list = (action.newSearch) ? action.payload.posts : [...state.newsList, ...action.payload.posts];

            return {
                ...state,
                newsListLoading: false,
                newsList: list,
                newsListErrors: {},
                hasMore: action.payload.hasMore,
                currentPage: action.page,
                fakeLoadingTime: action.fakeLoadingTime,
            };
        case NEWS_LIST_FAILURE:
            return {
                ...state,
                newsListLoading: false,
                newsList: [],
                newsListErrors: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/features/News/reducers.js